import React from 'react';
const MoreDots = () => (React.createElement("svg", { width: "100%", height: "100%", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("g", { fill: "currentColor" },
        React.createElement("circle", { cx: "5", cy: "12", r: "2" }),
        React.createElement("circle", { cx: "12", cy: "12", r: "2" }),
        React.createElement("circle", { cx: "19", cy: "12", r: "2" }))));
export default MoreDots;
//# sourceMappingURL=MoreDots.js.map